import { create } from "zustand";

type LoginPrefill = {
  phone: string;
  password: string;
};

interface LoginPrefillState extends LoginPrefill {
  setPrefill: (payload: LoginPrefill) => void;
  consumePrefill: () => LoginPrefill;
}

const emptyPrefill: LoginPrefill = {
  phone: "",
  password: "",
};

export const useLoginPrefillStore = create<LoginPrefillState>((set, get) => ({
  ...emptyPrefill,
  setPrefill: (payload) => set(payload),
  consumePrefill: () => {
    const { phone, password } = get();
    set(emptyPrefill);
    return { phone, password };
  },
}));
